export const normalizeAanmeldingen = (aanmeldingen, registration_lists) => {
  // return data,

  const kisten = {}
  const rollen = {

    vliegers: 0,
    prive: 0,
    club: 0,

    nieuw: 0,
    as_sleepvlieger: 0,

    checkstart: 0,
    overland: 0,

    wachtlijst: 0
  }

  // create a flat list of registration lists, all users that are on the wachtlijst
  const wachtlijstLeden = {}
  registration_lists && registration_lists.forEach((list) => {
    list?.registrations?.forEach((registration) => {

      // only if user is on all registration lists as waitlist he is on the wachtlijst
      if (!wachtlijstLeden[registration.user_id]) wachtlijstLeden[registration.user_id] = true

      if (!registration.is_waitlist) {
        wachtlijstLeden[registration.user_id] = false
      }
    }
    )
  })

  const sleep_vliegers = []

  aanmeldingen && aanmeldingen.forEach((aanmelding) => {
    // concat currency tab one level higher for quick lookup in tables
    aanmelding.vlieger = { ...aanmelding.vlieger, ...aanmelding.vlieger.currency }

    if (wachtlijstLeden[aanmelding.vlieger.id]) {
      aanmelding.wachtlijst = true
      rollen.wachtlijst += 1
      
    } else if (aanmelding.aangemeld) {
      // first rollen zijn mutual exclusive

      rollen.vliegers += 1
      if (aanmelding.checkstart) rollen.checkstart += 1

      // deemed more important because you signup for it explicitely
      if (aanmelding.as_instructeur) {
        rollen.as_instructeur += 1
      }
      if (aanmelding.as_sleepvlieger) {
        rollen.as_sleepvlieger += 1
        aanmelding.as_sleepvlieger = true
        sleep_vliegers.push(aanmelding)
      }

      if (aanmelding.kist?.includes('privé')) {
        rollen.prive += 1

      } else {
        rollen.club += 1

        // Voorkeuren voor kist
        if (aanmelding.kist && aanmelding.kist.length >= 1) {
          aanmelding.kist.forEach((kist, idx) => {
            
            if (!kisten[kist]) {
              kisten[kist] = {
                first: 0,
                later: 0,
              }
            }

            if (idx === 0) {
              kisten[kist].first += 1
            } else {
              kisten[kist].later += 1
            }
          })
        }

        aanmelding.vlieger?.group_keys.forEach(group => {
          if (!rollen[group]) rollen[group] = 0
          rollen[group] += 1
        })

        if (aanmelding.overland) rollen.overland += 1

        // nieuw lid is < 5 dbo flights
        if (aanmelding.vlieger && aanmelding.vlieger.group_keys?.includes('dbo') && aanmelding.vlieger.dbo <= 5) {
          rollen.nieuw += 1
          aanmelding.nieuw_lid = true
        }
      }
    }
  })

  // get all keys of kisten
  kisten.types = Object.keys(kisten)
  kisten.types.sort()

  return {
    aanmeldingen,
    sleep_vliegers,
    kisten,
    rollen
  }
}
